import { render, staticRenderFns } from "./PolygonMenu.vue?vue&type=template&id=2cabec74&scoped=true"
import script from "./PolygonMenu.vue?vue&type=script&lang=js"
export * from "./PolygonMenu.vue?vue&type=script&lang=js"
import style0 from "./PolygonMenu.vue?vue&type=style&index=0&id=2cabec74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cabec74",
  null
  
)

export default component.exports